import { render, staticRenderFns } from "./VQDate.vue?vue&type=template&id=37c2f1c1"
import script from "./VQDate.vue?vue&type=script&lang=js"
export * from "./VQDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports